export default "__VITE_ASSET__d657dd4b__"